import { LogoutOptions, useAuth0 } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
import { useMemo } from 'react'

import useBackendClient from '~/api/BackendClient/useBackendClient'

const useLogout = () => {
  const { logout } = useAuth0()
  const client = useBackendClient()

  const invalidateTokensAndLogout = useMemo(
    () => async (logoutOptions?: LogoutOptions) => {
      try {
        await client.user.invalidateTokens()
      } catch (e) {
        Sentry.captureException(e)
        console.error('Unable to invalidate tokens for logout', e)
      }

      await logout(logoutOptions)
    },
    [client, logout],
  )

  return {
    logout: invalidateTokensAndLogout,
  }
}

export default useLogout
